import { render } from "./picture.vue?vue&type=template&id=3060a918&scoped=true&ts=true"
import script from "./picture.vue?vue&type=script&lang=ts"
export * from "./picture.vue?vue&type=script&lang=ts"

import "./picture.vue?vue&type=style&index=0&id=3060a918&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3060a918"]])

export default __exports__